import React, { Component, Fragment } from 'react'
//import PropTypes from 'prop-types'
import axios from 'axios'
import { Collapse, Navbar, NavbarToggler, NavbarBrand } from 'reactstrap'
import { Container, Row, Col } from 'reactstrap'
import { NavLink } from 'react-router-dom'
import { AuthConsumer } from 'react-check-auth'
import axiosConfig from '../../config/axios'
import { ContentConsumer } from '../../language'
import NavList from './components/navList'
// MBQ TODO export default Colors
import { Colors } from './components/Colors'
import Modal from '../Modal/Modal'
import GpaResponsableModal from '../GpaResponsableModal/GpaResponsableModal'

// MBQ APR 2025 NEW LOGO
//import logo from '../../assets/images/Logo-Oxford-Premium.png'
import logo from '../../assets/images/logoOUPsolus_white.png'

import demo from '../../assets/images/demo.png'
import userRoles from '../../globals/userRoles'
import { isClassroomError, isStudentArea, isProductViewer } from '../../globals/envSettings'
import { Poll, ManagedSurvey } from 'components/Polls'
import { PARENT_COMPONENT } from 'components/Polls/ManagedSurvey/ManagedSurvey'
// MBQ NOV 2025 RESTYLING UX selection
//import UXSelector from './components/UXSelector'


const colors = ['red', 'pink', 'yellow', 'green', 'aqua', 'blue']

const axiosClient = axios.create({ ...axiosConfig })

class Header extends Component {
  constructor(props) {
    super(props)
    this.state = { isOpen: false, showResponsableModal: false }
  }

  handleCollapse = () => this.setState(prevState => ({
    isOpen: !prevState.isOpen
  }))

  toggleResponsableModal = fn => {
    this.setState(prevState => ({
      showResponsableModal: !prevState.showResponsableModal
    }))
    if (fn && typeof fn === 'function') fn()
  }

  render() {
    const { isOpen, showResponsableModal } = this.state
    const studentArea = isStudentArea(this.props.location.pathname)
    const classroomError = isClassroomError(this.props.location.pathname)
    const productViewer = isProductViewer(this.props.location.pathname)

    return (
      !productViewer ?
        (
          <div>
            <Navbar className="headerOUP" color="dark" expand="md">
              <AuthConsumer>
                {({ userInfo, refreshAuth }) => (
                  <ContentConsumer>
                    {({ content, locale, refreshContent }) => (content &&
                      <Fragment>
                        {((studentArea || classroomError) && !userInfo)
                          ? (
                            <NavbarBrand>
                              {/* MBQ APR 2025 NEW LOGO */}
                              {/* <img src={logo} className="mr-2" alt="Oxford Premium" /> */}
                              <Container fluid className='w-brand p-0 m-0'>
                                <Row className='w-brand'>
                                  <Col className='w-brand logo'>
                                    <img src={logo} className="mr-2" alt="Oxford Premium" />
                                  </Col>
                                  <Col className='w-brand text'>
                                    <Row className='h-50 align-items-end'>Oxford</Row>
                                    <Row className='h-50'>Premium</Row>
                                  </Col>
                                </Row>
                              </Container>
                            </NavbarBrand>
                          )
                          : (
                            <NavbarBrand tag={NavLink} to="/">
                              {/* MBQ APR 2025 NEW LOGO */}
                              {/*
                              <img src={logo} className="mr-2" alt="Oxford Premium" />
                              {userInfo && userInfo.role === userRoles.TEACHER_DEMO && <img src={demo} alt="Oxford Premium" />}
                              */}
                              <Container fluid className='w-brand p-0 m-0'>
                                <Row className='w-brand'>
                                  <Col className='w-brand logo'>
                                    <img src={logo} className="mr-2" alt="Oxford Premium" />
                                  </Col>
                                  <Col className='w-brand text'>
                                    <Row className='h-50 align-items-end'>Oxford</Row>
                                    <Row className='h-50'>Premium</Row>
                                  </Col>
                                  {userInfo && userInfo.role === userRoles.TEACHER_DEMO &&
                                    <Col className='w-brand demo align-content-center'>
                                      <img src={demo} alt="Oxford Premium" />
                                    </Col>
                                  }
                                </Row>
                              </Container>                              
                            </NavbarBrand>
                          )
                        }
                        {(!(studentArea || classroomError) || userInfo)
                          && <Fragment>
                            <Poll />                            
                            <NavbarToggler className="headerOUP__toggler" onClick={this.handleCollapse} />
                            <Collapse id="collapseTest" isOpen={isOpen} navbar>

                              {/* MBQ 2025 JUL OSP-2768 (ManagedSurvey button with new logo) */}
                              <ManagedSurvey parent={PARENT_COMPONENT.HEADER} className='header menu' />

                              <NavList
                                content={content}
                                userInfo={userInfo}
                                toggleResponsableModal={userInfo && this.toggleResponsableModal}
                                locale={!userInfo && locale}
                                onChangeLanguage={(language) => {
                                  if (userInfo) {
                                    axiosClient.put('/user/language', { language })
                                      .then(refreshAuth)
                                      .catch(() => { })
                                  } else {
                                    refreshContent(language)
                                  }
                                }} />
                            </Collapse>
                            {userInfo &&
                              <Modal className={'responsable_modal'} isOpen={showResponsableModal}
                                toggle={this.toggleResponsableModal}
                                header={content.gratisadoption.gxa_1}
                                subtitle={content.gratisadoption.gxa_3}
                              >
                                <GpaResponsableModal userInfo={userInfo} refreshAuth={refreshAuth} history={this.props.history} content={content} toggleModal={this.toggleResponsableModal} />
                              </Modal>
                            }
                          </Fragment>
                        }
                      </Fragment>
                    )}
                  </ContentConsumer>
                )}
              </AuthConsumer>
            </Navbar>
            <Colors colors={colors} />

            {/* MBQ 2025 JUL OSP-2768 (ManagedSurvey button with new logo) */}
            <ManagedSurvey parent={PARENT_COMPONENT.HEADER} className='header bottom-header' />

            {/* MBQ NOV 2025 RESTYLING UX selection */}
            {/*<UXSelector />*/}

          </div>
        )
        :
        ( null )
    )
  }
}

// MBQ TODO colors no viene del padre, se define en el componente actual como array invariable,
// por lo que es más una constante que una prop
// Trasladar colors al componente Colors en lugar de pasárselo como prop ????
// Revisar impacto en test
/*Header.propTypes = {
  colors: PropTypes.array
}
Header.defaultProps = {
  colors: []
}*/

export default Header